import Image from 'next/image';
import { useTranslation } from 'react-i18next';

import { Box, Flex, Heading, Text, useBreakpointValue } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { trackEvent } from '~/features/analytics/track-event';

import { BriefCaseIcon, UserIcon } from '../icons';

import { HeroLayout } from './hero-layout';

export function HomepageMainHeroSection() {
  const { t } = useTranslation();
  const objectPositionDesktopImage = useBreakpointValue(
    {
      base: '-6vw bottom',
      lg: 'top right',
    },
    {
      fallback: 'lg',
    }
  );
  return (
    <HeroLayout
      backgroundImageOverlayGradient={{
        xl: 'radial(circle at left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) 25%, rgba(0, 0, 0, 0) 70%, rgb(10, 11, 15) 92%)',
      }}
      backgroundImageSlot={
        <>
          <Box display={{ base: 'block', md: 'none' }} inset={0} position='absolute'>
            <Image
              alt=''
              quality={100}
              sizes='100vw'
              src='/images/experiments/ab_plp_redesign_2025/it-worker-with-headphones-mobile.png'
              style={{ objectFit: 'cover', objectPosition: 'right top', minWidth: '412px' }}
              fill
              priority
            />
          </Box>
          <Box bottom='-2px' display={{ base: 'none', md: 'block' }} left={0} position='absolute' right={0} top={0}>
            <Image
              alt=''
              quality={100}
              sizes='100vw'
              src='/images/experiments/ab_plp_redesign_2025/it-worker-with-headphones-v2.png'
              style={{ objectFit: 'cover', objectPosition: objectPositionDesktopImage }}
              fill
              priority
            />
          </Box>
        </>
      }
      ctaSlot={
        <>
          <ButtonLink
            buttonProps={{
              leftIcon: <UserIcon height='20px' width='20px' />,
              flex: {
                base: 1,
                md: 'unset',
              },
              onClick: () =>
                trackEvent({
                  name: 'Homepage CTA Clicked',
                  type: 'click',
                  label: 'HP_banner_option_clicked',
                  value: 'Individuals',
                }),
            }}
            linkProps={{
              href: '/experience',
            }}
          >
            {t('common.forIndividuals')}
          </ButtonLink>
          <ButtonLink
            buttonProps={{
              leftIcon: <BriefCaseIcon height='20px' width='20px' />,
              variant: 'outline',
              colorScheme: 'white',
              flex: {
                base: 1,
                md: 'unset',
              },
              onClick: () =>
                trackEvent({
                  name: 'Homepage CTA Clicked',
                  type: 'click',
                  label: 'HP_banner_option_clicked',
                  value: 'Businesses',
                }),
            }}
            linkProps={{
              href: '/enterprise/overview',
            }}
          >
            {t('common.forBusinesses')}
          </ButtonLink>
        </>
      }
      minHeight={{
        md: '674px',
      }}
      textContentSlot={
        <Flex
          flexDirection='column'
          gap={8}
          whiteSpace='pre-wrap'
          maxWidth={{
            base: '286px',
            md: '444px',
          }}
        >
          <Heading
            as='h1'
            color='white'
            fontWeight='500'
            fontSize={{
              base: '3.25rem',
              md: '4.75rem',
            }}
            lineHeight={{
              base: '1.1',
              md: '0.95',
            }}
          >
            {t('home.hero.title')}
          </Heading>
          <Text color='gray.300' fontSize='lg' lineHeight='lg'>
            {t('home.hero.description')}
          </Text>
        </Flex>
      }
    />
  );
}
